import { render, staticRenderFns } from "./FollowupsListDialog.vue?vue&type=template&id=6617f613&scoped=true"
import script from "./FollowupsListDialog.vue?vue&type=script&lang=js"
export * from "./FollowupsListDialog.vue?vue&type=script&lang=js"
import style0 from "./FollowupsListDialog.vue?vue&type=style&index=0&id=6617f613&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6617f613",
  null
  
)

export default component.exports